import React from 'react';

import t from '../../../labels/labelling-utils';
import { makeClassNames } from '../../../utils/styles';
import './card-adv.scss';

export interface ICardAdv {
  advBoxAttributes?: React.HTMLAttributes<HTMLDivElement>;
  shiftingContent?: boolean;
  fakeAdvs?: boolean;
}

const CardAdv = (props: ICardAdv) => {
  const { advBoxAttributes, shiftingContent = false, fakeAdvs = false } = props;

  const fakeAdvsImages = ['https://placehold.co/300x250/jpg', 'https://placehold.co/300x600/jpg'];

  const classNames = (params: { shiftingContent: boolean }) => {
    const { shiftingContent } = params;

    return makeClassNames({
      cardAdv: 'card-adv',
      cardAdvContent: ['card-adv__content', shiftingContent && 'card-adv__content--shifting'],
      advLabel: 'card-adv__adv-label',
    });
  };

  const cn = classNames({ shiftingContent });

  return (
    <div className={cn.cardAdv}>
      <div className={cn.cardAdvContent} data-card-adv-content {...advBoxAttributes!}>
        <div className={cn.advLabel}>{t('adv.label')}</div>
        {fakeAdvs ? <img src={fakeAdvsImages[Math.floor(Math.random() * fakeAdvsImages.length)]} /> : null}
      </div>
    </div>
  );
};

export default CardAdv;
